import React from 'react';
import { StepComponentProps } from '../wizard.model';
import { PolicyMode } from '../../../../utils/enums';
import { SystemConfiguration } from '../../../../utils/system-configuration';
import { keyboardClickable } from '../../../../utils/a11y-utils';
import Protection from '@svg/shield-icon.svg?react';
import PersonalSecurity from '@svg/personal-security.svg?react';
import './policy-step.scss';
import QuickStartBlockedItems from './quick-start-blocked-items';

const PolicyStep: React.FC<StepComponentProps> = ({ data ,onDataChange }) => {

    const handlePolicyChange = (policy: string) => {
        onDataChange({ policy });
    };
    
    const policies =  [
        {
            icon: <Protection />,
            title: 'Quick Start',
            subTitle: 'Foundational coverage',
            description: (
                <>
                    Protection from threats AT&T experts have curated for you,
                    prioritizing network traffic over deep policy creation
                    and customization.
                    Quick Start applies protection against known
                    high risk threats over personalized policy protections.
                    <QuickStartBlockedItems serviceLevel={data.connection?.serviceLevel} />
                </>
            ),
            isPreferred: false,
            type: PolicyMode.QUICK_START
        },
        {
            icon: <PersonalSecurity />,
            title: 'Smart Protection',
            subTitle: 'Automated & personalized',
            description: `We’ll generate a custom policy after ${SystemConfiguration.getInstance().policyGeneratorAnalysisDays}
                days of personalized traffic analysis,
                filtering out what you don’t use.
                The custom policy will include protection against known high risk threats.
                You can adjust this policy to meet the changing needs of your business.
                During this period, your network will be protected by AT&T Dynamic Defense Shield.`,
            isPreferred: true,
            type: PolicyMode.SMART_POLICY
        }
    ];

    return (
        <div className="step">
            <div className="step-header">Select a policy</div>
            <div className="step-desc">Great! Now select a security policy that’s best suited
                for {data.nickname || data.connection?.serviceName || data.connection?.adiCircuitId},
                <br />
                or skip to create your policy from scratch.
            </div>
            <div className="step-content policy-step-cards">
                {policies.map(card => (
                    <div key={card.title} className={`card ${data.policy === card.type ? 'active' : ''}`}
                         {...keyboardClickable(() => handlePolicyChange(card.type))}>
                        {card.isPreferred && <span className="card-preferred-label">PREFERRED</span>}
                        <div className="card-icon">{card.icon}</div>
                        <div className="card-title">{card.title}</div>
                        <div className="card-subtitle">{card.subTitle}</div>
                        <div className="card-description">{card.description}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PolicyStep;